/**
 * Analytics Pageview Plugin
 *
 * Tracks virtual pageviews on SPA route changes.
 * Also tracks initial pageview on app mount.
 *
 * Important: GA4 Configuration Tag must have "Send page view event" DISABLED
 * to avoid duplicate pageviews on initial load.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const { trackPageview, isEnabled } = useAnalytics()

  if (!isEnabled.value) return

  // Track initial pageview
  trackPageview()

  // Track subsequent route changes
  router.afterEach((to, from) => {
    // Skip if same path (e.g., hash change only)
    if (to.path === from.path) return

    // Small delay to ensure page title is updated
    nextTick(() => {
      trackPageview(to.path)
    })
  })
})
